import { getCatalogue } from './catalogueClient';

export const getBrands = async (options) => {
  return getCatalogue('brands', [], 'getBrandsV2', undefined, options);
};
